import { cn } from "@/libraries/cn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Radio from "@mui/material/Radio";
import { forwardRef } from "react";
import { Typography } from "../text";

interface RadioCardProps extends React.ComponentPropsWithoutRef<"label"> {
	checked?: boolean;
	value: string | number;
	title: string;
	info?: string;
	inputProps: NonNullable<React.ComponentProps<typeof Radio>["inputProps"]>;
}

const RadioCard = forwardRef<HTMLInputElement, RadioCardProps>((props, ref) => {
	const { title, info, className, checked, value, inputProps } = props;
	return (
		<label
			htmlFor={`radio-${value}`}
			className={cn(
				"cursor-pointer flex p-4 rounded-xl border border-zinc-950 has-[:checked]:bg-primary-light has-[:checked]:border-primary",
				className,
			)}
		>
			<div className="flex-1 flex flex-col justify-center">
				<Typography fontWeight={700} fontSize={14}>
					{title}
				</Typography>
				{info ? (
					<Typography fontWeight={400} fontSize={12}>
						{info}
					</Typography>
				) : null}
			</div>
			<Radio
				value={value}
				id={`radio-${value}`}
				inputRef={ref}
				checkedIcon={<CheckCircleIcon />}
				edge="end"
				tabIndex={-1}
				disableRipple
				checked={checked}
				inputProps={inputProps}
			/>
		</label>
	);
});

export default RadioCard;
